import type { CrtNotificationEvent } from '@repo/constants'

/**
 * The hashes of the settings page's dialogs: `/crt/settings#<anchor>` opens that dialog, so other
 * pages can link straight to one (e.g. the data issues' "Set targets").
 */
export const SETTINGS_ANCHORS = {
  currencyRates: 'currency-rates',
  lmcTargets: 'lmc-targets',
} as const

/**
 * The hash of each email's dialog in the settings page's Email Notifications section. Keyed by event,
 * so an event added later needs its anchor here before it can be listed.
 */
export const NOTIFICATION_ANCHORS = {
  missing_imports: 'missing-imports-email',
} as const satisfies Record<CrtNotificationEvent, string>

/** The id of the Email Notifications section: linking to it scrolls there without opening a dialog. */
export const EMAIL_NOTIFICATIONS_SECTION_ID = 'email-notifications'

export type SettingsAnchor =
  | (typeof SETTINGS_ANCHORS)[keyof typeof SETTINGS_ANCHORS]
  | (typeof NOTIFICATION_ANCHORS)[CrtNotificationEvent]
